'use strict';

window.console || (window.console = {
	log: function log() {}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = '';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (var i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (var _i = 0; _i < ajaxLen; _i++) {
					ajaxArrayList[_i] = $.ajax({
						type: 'GET',
						url: ajaxArray[_i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					if (args[1] === 'success') {
						// includeが1個だけの場合
						var position = $(args[0]).filter(':first').attr('class').split(' ');
						for (var j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						// console.log('Succeeded to read the include file!:', position);
					} else {
						for (var _i2 = 0; _i2 < args.length; _i2++) {
							var result = args[_i2];
							var _position = $(result[0]).filter(':first').attr('class').split(' ');

							for (var _j = 0; _j < _position.length; _j++) {
								if (_position[_j].match(regExp)) {
									_position = _position[_j];
									break;
								}
							}
							$('.' + _position).html(result[0]).children().unwrap();

							// console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= 0;
						if ($('.consumer-detail-nav-float').length) {
							pos -= 47;
						}
					} else {
						pos -= 0;
						if ($('.consumer-detail-nav-float').length) {
							pos -= 71;
						}
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		modal: function modal() {
			$('.mod-modal').on('click', function (e) {
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span></span></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
			$('.mod-modal-youtube').on('click', function (e) {
				var HTML = '<div class="mod-modal-youtube-overlay">';
				HTML += '<div class="mod-modal-youtube-closeArea"></div>' + '<span class="mod-modal-youtube-closeBtn"><span></span></span>' + ('<div class="mod-modal-youtube-content"><div class="mod-youtube"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + $(e.currentTarget).data('id') + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div></div>') + '</div>';
				$('body').append(HTML);
				var $overlay = $('.mod-modal-youtube-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-youtube-closeArea, .mod-modal-youtube-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload: function lazyload() {
			if ($(".js-lazy-img").length) {
				$(".js-lazy-img").lazyload();
			}
		},
		openSearchBox: function openSearchBox() {
			var $btn = $('.js-search_open');
			var $btnClose = $('.js-close_bg');
			$btn.on('click', function () {
				$('.header-common-search_box').addClass(a);
				$('.js-search_hide').css('display', 'none');
				$('.header-common-content-list').addClass(a);
			});
			$btnClose.on('click', function () {
				$('.header-common-search_box').removeClass(a);
				$('.js-search_hide').css('display', 'flex');
				$('.header-common-content-list').removeClass(a);
			});
		},

		// ヘッダーグロナビのカレント表示
		headerCurrent: function headerCurrent() {
			if ($('.header-navi-list-item-text').length) {
				$('.header-navi-list-item-text').each(function (idx, val) {
					if (location.pathname.indexOf($(val).attr('href').replace('index.html', '')) != -1) {
						$(val).addClass(a);
					}
				});
			}
		},

		// SP版のヘッダーのハンバーガーメニュー
		spMenu: function spMenu() {
			var $menu = $('.js-menuToggle');
			var $navi = $('.js-naviToggle');
			var $global = $('.js-globalToggle');
			var $toIcon = $('.js-toIconToggle');
			var scrollTopNow = 0;

			var openMenu = function openMenu() {
				//メニューを開く
				scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
				$menu.addClass(a);
				$navi.addClass(a);
				$global.addClass(a);
				$toIcon.removeClass(a);
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};

			var closeMenu = function closeMenu() {
				//メニューを閉じる
				$menu.removeClass(a);
				$navi.removeClass(a);
				$global.removeClass(a);
				$toIcon.addClass(a);
				$('.container').css({
					position: 'static'
				});

				if ($('body').hasClass(f)) {
					$('body').removeClass(f);

					$(window).scrollTop(scrollTopNow);
				}
			};

			$menu.on('click', function () {
				if ($menu.hasClass(a)) {
					closeMenu();
				} else {
					openMenu();
				}
			});

			$(window).resize(function () {
				var windowWidth = $(window).width();
				if (windowWidth > 1024) {
					closeMenu();
				}
			});
		},
		animation: function animation() {
			// 下からアニメーション
			if ($('.js-inview-bottom').length) {
				$('.js-inview-bottom').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 左からアニメーション
			if ($('.js-inview-left').length) {
				$('.js-inview-left').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 右からアニメーション
			if ($('.js-inview-right').length) {
				$('.js-inview-right').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 下からふわっとアニメーション　
			if ($('.js-fadein-bottom-opacity').length) {
				$('.js-fadein-bottom-opacity').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					}
				}, { offset: '70%' });
			}
		},
		scrollEvents: function scrollEvents() {
			var headerHidePosition = 0;
			var headerHide = function headerHide() {
				var headerHight = $('.header').height();
				var thisScroll = $(window).scrollTop();
				if (thisScroll > 0) {
					if (thisScroll < headerHidePosition) {
						// /consumer/lenses/詳細では非表示
						if (!$('.consumer-detail-nav-float').length) {
							$('.header').css('top', '0px');
						}
					} else {
						$('.header').css('top', '-' + headerHight + 'px');
					}
				} else {
					$('.header').css('top', '0px');
				}
				headerHidePosition = thisScroll;
				// console.log(thisScroll,headerHidePosition);
			};
			var pageTop = function pageTop() {
				var $pagetop = $('.footer-pagetop-warp');
				var $footer = $('.footer');
				var $footerBtnArea = $('.footer-top-content-btn_area_sp');
				var $container = $('.container');
				var footerPos = $footer.offset().top - $(window).height();
				var footerBtnAreaPos = $footerBtnArea.offset().top - $(window).height();
				var marginTopPc = 32;
				var marginBttomPc = 32;
				var marginTopSp = 20;
				var marginBttomSp = 20;
				var btnHeight = 50;
				var width = $(window).width();
				var thisScroll = $(window).scrollTop();
				var btnStopPos = 0;

				if ($container.hasClass('top')) {
					//トップページの場合はフッター上でトップに戻るボタンが止まる
					btnStopPos = footerPos;
				} else {
					if (width > 1024) {
						btnStopPos = footerPos + marginTopPc + marginBttomPc + btnHeight;
					} else {
						btnStopPos = footerBtnAreaPos + marginTopSp + btnHeight + marginBttomSp;
					}
				}

				if (thisScroll > btnStopPos) {
					$pagetop.addClass(v);
					$pagetop.addClass('is-stop');
				} else if (thisScroll > '150') {
					$pagetop.addClass(v);
					$pagetop.removeClass('is-stop');
				} else {
					$pagetop.removeClass(v);
					$pagetop.removeClass('is-stop');
				}
			};
			$(window).on('scroll', function () {
				headerHide();
				pageTop();
			});
		},
		tabchange: function tabchange() {
			if ($('.js-tabchange').length) {
				// クリックされたときの動作
				$('.js-tabchange').on('click', function () {
					$(this).parents('.js-tabchangeWrap').find('.js-tabchange').removeClass(a);
					$(this).addClass(a);
					var index = $(this).parents('.js-tabchangeWrap').find('.js-tabchange').index(this);
					$(this).parents('.js-tabchangeWrap').find('.js-tabchange-list').removeClass(a).eq(index).addClass(a);
					$(this).parents('.js-tabchangeWrap').find('.js-tabchange-content').removeClass(a).eq(index).addClass(a);
				});
				// 初期化ではじめのタブをアクティブにする
				$('.js-tabchange').eq(0).addClass(a);
				$('.js-tabchange-list').eq(0).addClass(a);
				$('.js-tabchange-content').eq(0).addClass(a);
				// リンクで飛んできたときの動作
				// パラメータにtabnumがあったときはtabnumに入った数字(0～)のタブを開く
				if ($(location).attr('search').length) {
					var paramString = $(location).attr('search').slice(1);
					var paramPairs = paramString.split('&');
					for (var i = 0; i < paramPairs.length; i++) {
						var pair = paramPairs[i].split('=');
						if (pair[0] === 'tabnum') {
							var tabNum = Number(pair[1]);
							$('.js-tabchange').eq(tabNum).parents('.js-tabchangeWrap').find('.js-tabchange').removeClass(a);
							$('.js-tabchange').eq(tabNum).addClass(a);
							$('.js-tabchange').eq(tabNum).parents('.js-tabchangeWrap').find('.js-tabchange-list').removeClass(a).eq(tabNum).addClass(a);
							$('.js-tabchange').eq(tabNum).parents('.js-tabchangeWrap').find('.js-tabchange-content').removeClass(a).eq(tabNum).addClass(a);
						}
					}
				}
			}
		},
		share: function share() {
			if ($('.mod-share').length) {
				var pageUrl = document.URL;
				var shareUrl = "";
				var sharePagetitle = encodeURIComponent(document.title);
				// facebook
				if ($('.mod-share ._facebook').length) {
					shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
					$('.mod-share ._facebook').attr('href', shareUrl);
				}
				// twitter
				if ($('.mod-share ._twitter').length) {
					shareUrl = 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + sharePagetitle;
					$('.mod-share ._twitter').attr('href', shareUrl);
				}
				// line
				if ($('.mod-share ._line').length) {
					shareUrl = 'https://timeline.line.me/social-plugin/share?url=' + pageUrl + '&text=' + sharePagetitle;
					$('.mod-share ._line').attr('href', shareUrl);
				}
				// linkedin
				if ($('.mod-share ._linkedin').length) {
					shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + pageUrl;
					$('.mod-share ._linkedin').attr('href', shareUrl);
				}
				// mail
				if ($('.mod-share ._mail').length) {
					shareUrl = 'mailto:?body=' + pageUrl;
					$('.mod-share ._mail').attr('href', shareUrl);
				}
			}
		},
		tel: function tel() {
			var ua = navigator.userAgent.toLowerCase();
			var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);
			if (!isMobile) {
				if ($('a[href^="tel:"]').length) {
					$('a[href^="tel:"]').on('click', function (e) {
						e.preventDefault();
					});
				}
			}
		},
		openingAnimation: function openingAnimation() {
			if ($('.js-opening_top').length) {
				// /$lang$/ -------------------------------
				if ($('.top-mv-slide01').length) {
					$('.top-mv-slide01').slick({
						autoplay: false,
						autoplaySpeed: 3000,
						speed: 3000,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: false,
						infinite: true,
						fade: true,
						swipe: false,
						pauseOnFocus: false,
						pauseOnHover: false
					});
					$('.top-mv-slide02').slick({
						autoplay: false,
						autoplaySpeed: 3000,
						speed: 3000,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: false,
						infinite: true,
						fade: true,
						swipe: false,
						pauseOnFocus: false,
						pauseOnHover: false
					});
				}
				var topmvslidePlay = function topmvslidePlay() {
					$('.top-mv-slide01').slick('slickPlay');
					setTimeout(function () {
						$('.top-mv-slide02').slick('slickPlay');
					}, 3000);
				};
				// /$lang$/company/ -------------------------------
				var companyvideoVisible = function companyvideoVisible() {
					$('.company-head01 video').removeClass('di_none');
				};
				// /$lang$/biz/ -------------------------------
				if ($('.biz-top-mv-slide').length) {
					$('.biz-top-mv-slide').slick({
						dots: false,
						infinite: true,
						speed: 500,
						fade: true,
						cssEase: 'linear',
						autoplay: false,
						autoplaySpeed: 5000,
						arrows: false,
						pauseOnFocus: false,
						pauseOnHover: false,
						pauseOnDotsHover: false
					});
				}
				var bizmvslidePlay = function bizmvslidePlay() {
					$('.biz-top-mv-slide').slick('slickPlay');
				};
				// -------------------------------
				if (!sessionStorage.getItem('opening_top')) {
					sessionStorage.setItem('opening_top', 'ok');
					$('.js-opening_top').append('<div class="opening_top"><span class="opening_top-logo"><img src="/common/images/logo.svg" alt="TAMRON Focus on the Future"></span><span class="opening_top-obj"></span></div>');
					$('.js-opening_top').addClass(a);
					setTimeout(function () {
						$('.js-opening_top').removeClass(a);
						$('.js-opening_top').removeClass('is-initial');
						if ($('.top-slide').length) {
							topmvslidePlay();
						}
						if ($('.company-head01 video').length) {
							companyvideoVisible();
						}
						if ($('.consumer-slide01').length) {
							consumermvslidePlay();
						}
						if ($('.biz-top-mv-slide').length) {
							bizmvslidePlay();
						}
						if ($('.js-inview-bottom_opening').length) {
							$('.js-inview-bottom_opening').waypoint(function (direction) {
								var activePoint = $(this.element);
								if (direction === 'down') {
									// scroll down
									activePoint.addClass(a);
								} else {
									// scroll up
									activePoint.removeClass(a);
								}
							}, { offset: '70%' });
						}
					}, 2500);
				} else {
					$('.js-opening_top').removeClass('is-initial');
					if ($('.top-slide').length) {
						topmvslidePlay();
					}
					if ($('.company-head01 video').length) {
						companyvideoVisible();
					}
					if ($('.consumer-slide01').length) {
						consumermvslidePlay();
					}
					if ($('.biz-top-mv-slide').length) {
						bizmvslidePlay();
					}
					if ($('.js-inview-bottom_opening').length) {
						$('.js-inview-bottom_opening').waypoint(function (direction) {
							var activePoint = $(this.element);
							if (direction === 'down') {
								// scroll down
								activePoint.addClass(a);
							} else {
								// scroll up
								activePoint.removeClass(a);
							}
						}, { offset: '70%' });
					}
				}
			}
			// /$lang$/consumer/ -------------------------------
			if ($('.consumer-slide01').length) {
				// console.log("consumer-slide01");
				$('.consumer-slide01').slick({
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left_03" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right_03" /></svg></a>',
					dots: true,
					infinite: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							arrows: false
						}
					}]
				});
			}
			var consumermvslidePlay = function consumermvslidePlay() {
				$('.consumer-slide01').slick('slickPlay');
			};
		},
		contactLink: function contactLink() {
			if ($('.technology .js-contactLink').length) {
				$('.technology .js-contactLink').attr('href', '/' + location.pathname.split('/')[1] + '/contact/technology/?inquiry_type=');
			}
		},
		fileSizeEx: function fileSizeEx() {
			var setFileSize = function setFileSize(className) {
				// console.log(className);
				if ($(className).length) {
					$(className).each(function () {
						$(this).text(bytesToSize($(this).text()));
					});
				}
				function bytesToSize(bytes) {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
			};
			setFileSize('.js-fileSizeEx');
			setFileSize('.rt_cf_n_attachment_file_size');
		},
		gdpr: function gdpr() {
			if (location.pathname.split('/')[1] === 'global') {
				var f = 'is-fixed';
				var n = 'di_none';
				var a = 'is-active';
				var cookieIf = document.cookie.indexOf('gdprCookieData');
				if (cookieIf == -1) {
					// クッキーの場合こちら
					var bodyHtml = document.querySelectorAll('body');
					var addHtml = document.createElement('div');
					var addHtmlBtn = '';
					addHtml.className = 'gdpr_modal';
					addHtml.innerHTML = '<div class="gdpr_modal-content"><div class="_in"><p>In order to optimize our website for you and to be able to continuously improve it, we use cookies. By continuing to use the website, you agree to the use of cookies. More details in our <a href="/global/terms_of_use/personal_information.html" target="_blank">Privacy Notice</a></p><p class="gdpr_modal-content-box"><button id="gdpr_modal-btn" class="gdpr_modal-btn" type="button">Continue</button></p></div></div>';
					bodyHtml[0].appendChild(addHtml);
					addHtmlBtn = document.getElementById('gdpr_modal-btn');
					addHtmlBtn.addEventListener('click', function () {
						addHtml.classList.add(n);
						// クッキーの場合こちら
						var now = new Date();
						now.setDate(now.getDate() + 7);
						document.cookie = 'gdprCookieData=ok;expires=' + now.toUTCString() + ';path=/;';
					});
				}
			}
		},
		jsaltcheck: function jsaltcheck() {
			if (document.querySelector('.js-alt-check')) {
				var altText = document.querySelector('.js-alt-check').textContent.trim();
				// .inc_detail_block 配下の画像を取得
				var images = document.querySelectorAll('.inc_detail_block img');
				// alt が空または存在しない画像要素をフィルタリング
				var imagesWithEmptyAlt = Array.from(images).filter(function (img) {
					return !img.alt || img.alt.trim() === "";
				});
				// alt が空または存在しない画像にテキストを設定
				if (imagesWithEmptyAlt.length > 0) {
					// console.log(`${imagesWithEmptyAlt.length} つの画像が alt 属性を持っていなかった、または空でした。修正します。`);
					imagesWithEmptyAlt.forEach(function (img, index) {
						// console.log(`画像 ${index + 1}:`, img);
						img.alt = altText; // alt 属性に .js-alt-check のテキストコンテンツを設定
					});
				}
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.modal();
			_this.lazyload();
			_this.openSearchBox();
			_this.headerCurrent();
			_this.spMenu();
			_this.animation();
			_this.scrollEvents();
			_this.tabchange();
			_this.share();
			_this.tel();
			_this.openingAnimation();
			_this.contactLink();
			_this.fileSizeEx();
			_this.jsaltcheck();
			// _this.gdpr();
			svg4everybody();
		}
	};

	$(function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);
$(window).on('load', function () {
	var easeScrollHash = function easeScrollHash() {
		if (location.hash) {
			$('html, body').css('opacity', '0');
			setTimeout(function () {
				$('html, body').css('opacity', '1');
				if (document.querySelectorAll('.js-consumer-soft-lensutilityimgset').length) {
					var getImg = function getImg(_src) {
						return new Promise(function (resolve, reject) {
							var image = new Image();
							image.src = _src;
							image.onload = function () {
								resolve(image);
							};
							image.onerror = function (error) {
								reject(error);
							};
						});
					};
					var imgs = document.getElementsByTagName('img');

					var _loop = function _loop(img) {
						var src = img.getAttribute('src');
						getImg(src).then(function (res) {
							if (!img.hasAttribute('width')) {
								img.setAttribute('width', res.width);
							}
							if (!img.hasAttribute('height')) {
								img.setAttribute('height', res.height);
							}
						}).catch(function (error) {
							console.log(error);
						});
					};

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = imgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var img = _step.value;

							_loop(img);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				}
				var _hash = '#' + location.hash.split('#')[1];
				var pos = $(_hash).offset().top;
				if ($(window).width() < 768) {
					pos -= 0;
					if ($('.consumer-detail-nav-float').length) {
						pos -= 47;
					}
				} else {
					pos -= 0;
					if ($('.consumer-detail-nav-float').length) {
						pos -= 71;
					}
				}
				$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
				if ($(_hash).hasClass('js-toggle')) {
					$(_hash).addClass('is-active');
					$(_hash).next('.js-toggleBlock').stop().slideToggle('400');
				}
			}, 100);
		}
	};
	var slider = function slider() {
		if ($('.mod-slide01').length) {
			$('.mod-slide01').slick({
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				infinite: true,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						dots: true,
						draggable: true
					}
				}]
			});
		}
		if ($('.mod-slide02').length) {
			$('.mod-slide02').slick({
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				infinite: true,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						dots: true,
						draggable: true,
						arrows: true,
						prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
						nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>'
					}
				}]
			});
			for (var i = 0; i < $('.mod-slide02').length; i++) {
				var imgHeight = $('.mod-slide02-item img').eq(i).height() / 2;
				var arrowpos = imgHeight - $('.mod-slide02').eq(i).find('.slick-arrow').height() / 2;
				$('.mod-slide02').eq(i).find('.slick-arrow').css('top', arrowpos);
			}
			$('.mod-slide02').css('display', 'block');
		}
		if ($('.mod-slide03').length) {
			$('.mod-slide03-slider').slick({
				autoplay: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				asNavFor: '.mod-slide03-thumbnail'
			});
			for (var _i3 = 0; _i3 < $('.mod-slide03-slider').length; _i3++) {
				var _imgHeight = $('.mod-slide03-slider-item img').eq(_i3).height() / 2;
				var _arrowpos = _imgHeight - $('.mod-slide03-slider').eq(_i3).find('.slick-arrow').height() / 2;
				$('.mod-slide03-slider').eq(_i3).find('.slick-arrow').css('top', _arrowpos);
			}
			$('.mod-slide03-thumbnail').slick({
				slidesToShow: 4,
				asNavFor: '.mod-slide03-slider',
				focusOnSelect: true
			});
			$('.mod-slide03').css('display', 'block');
		}
		if ($('.mod-slide04').length) {
			$('.mod-slide04').slick({
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				infinite: true,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}]
			});
			for (var _i4 = 0; _i4 < $('.mod-slide04').length; _i4++) {
				var _imgHeight2 = $('.mod-slide04-item img').eq(_i4).height() / 2;
				var _arrowpos2 = _imgHeight2 - $('.mod-slide04').eq(_i4).find('.slick-arrow').height() / 2;
				$('.mod-slide04').eq(_i4).find('.slick-arrow').css('top', _arrowpos2);
			}
			$('.mod-slide04').css('display', 'block');
		}
	};
	easeScrollHash();
	slider();
});